// Country and language cookies
export const COOKIE_EXPIRE_DAYS = 365;
export const PREFERRED_COUNTRY_COOKIE_NAME = 'pref_country';
export const PREFERRED_LANGUAGE_COOKIE_NAME = 'pref_language';
export const QR_CODE_WIDTH = 200;
